import { Box } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { usePublicSchool } from '@/context/PublicSchoolContext';
import { Loader } from '@/components/feedback/Loader';

import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { QuickInfo } from './components/QuickInfo';
import { AboutSchool } from './components/AboutSchool';
import { PrincipalMessage } from './components/PrincipalMessage';
import { SchoolHighlights } from './components/SchoolHighlights';
import { Academics } from './components/Academics';
import { Facilities } from './components/Facilities';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Statistics } from './components/Statistics';
import { Gallery } from './components/Gallery';
import { VideoGallery } from './components/VideoGallery';
import { LatestEvents } from './components/LatestEvents';
import { LatestNews } from './components/LatestNews';
import { Testimonials } from './components/Testimonials';
import { FacultyPreview } from './components/FacultyPreview';
import { AdmissionProcess } from './components/AdmissionProcess';
import { CallToAction } from './components/CallToAction';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { WebsiteUnavailable } from './components/WebsiteUnavailable';
import { ScrollNavigationControls } from './components/ScrollNavigationControls';

export function PublicWebsitePage() {
  const { publicSchoolData, isLoading } = usePublicSchool();

  if (isLoading) {
    return <Loader fullScreen message="Loading School Website..." />;
  }

  if (publicSchoolData.website_enabled === false) {
    if (publicSchoolData.erp_enabled !== false) {
      return <Navigate to="/ERP" replace />;
    }
    return <WebsiteUnavailable data={publicSchoolData} />;
  }

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', backgroundColor: '#ffffff' }}>
      <Navbar data={publicSchoolData} />
      <Hero data={publicSchoolData} />
      <QuickInfo data={publicSchoolData} />
      <AboutSchool data={publicSchoolData} />
      <PrincipalMessage data={publicSchoolData} />
      <SchoolHighlights data={publicSchoolData} />
      <Academics data={publicSchoolData} />
      <Facilities data={publicSchoolData} />
      <WhyChooseUs data={publicSchoolData} />
      <Statistics data={publicSchoolData} />
      <Gallery data={publicSchoolData} />
      <VideoGallery data={publicSchoolData} />
      <LatestEvents data={publicSchoolData} />
      <LatestNews data={publicSchoolData} />
      <Testimonials data={publicSchoolData} />
      <FacultyPreview data={publicSchoolData} />
      <AdmissionProcess data={publicSchoolData} />
      <CallToAction data={publicSchoolData} />
      <ContactSection data={publicSchoolData} />
      <Footer data={publicSchoolData} />
      <ScrollNavigationControls data={publicSchoolData} />
    </Box>
  );
}

export default PublicWebsitePage;
